import { render } from "./footer.vue?vue&type=template&id=0181536e&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=0181536e&scoped=true&lang=css"

import exportComponent from "D:\\Project\\kunlun\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0181536e"]])

export default __exports__